import React from 'react';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { ActivityTemplate } from './types';
import TemplateDetailsDialog from './TemplateDetailsDialog';

type Props = {
  templates: ActivityTemplate[];
  disabled?: boolean;
  applying: boolean;
  onApply: (templateCode: string) => Promise<void>;
};

export class TemplateLibraryPanel extends React.Component<Props,any> {

  state = {
    selectedTemplate: null,
    detailsOpen: false,
  };

  render(){
    const {templates, disabled, applying, onApply } = this.props;
    return (
      <Box>
        <Typography variant="h6" sx={{ mb: 1 }}>Template Library</Typography>
        <Stack spacing={1}>
          {templates.map((template) => (
            <Card key={template.code} variant="outlined">
              <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="center">
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{template.name}</Typography>
                    <Typography variant="caption" color="text.secondary">{template.description || template.code}</Typography>
                  </Box>
                  <Stack direction="row" spacing={1}>
                    <Button size="small" variant="outlined" disabled={disabled} onClick={() => this.setState({ selectedTemplate: template, detailsOpen: true })}>Preview</Button>
                    <Button size="small" variant="outlined" disabled={disabled} onClick={() => onApply(template.code)}>Apply</Button>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
        <TemplateDetailsDialog
          open={this.state.detailsOpen}
          template={this.state.selectedTemplate}
          applying={this.props.applying}
          onClose={() => this.setState({ detailsOpen: false })}
          onApply={(code) => {
            this.setState({ detailsOpen: false });
            this.props.onApply(code);
          }}
        />
      </Box>
    );
  }
}

export default TemplateLibraryPanel;
